import AmexSecurityCenterAiIntegrations from './AmexSecurityCenterAiIntegrations';

export default AmexSecurityCenterAiIntegrations;
